module.exports = __webpack_public_path__ + "img/testimonial-video-thumbnail.226a411.webp";